import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { ArticleContent } from './components/ArticleContent';
import { Sidebar } from './components/Sidebar';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { Kontakt } from './pages/Kontakt';
function Layout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Outlet data-id="element-2" />
      <Footer data-id="element-3" />
    </div>;
}
function ArticlePage() {
  return <div className="max-w-[1100px] mx-auto w-full px-6 py-10 flex-1" data-id="element-4">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_300px] gap-10 md:gap-[60px]" data-id="element-5">
        <ArticleContent data-id="element-6" />
        <Sidebar data-id="element-7" />
      </div>
    </div>;
}
export function App() {
  return <>
      <Routes data-id="element-8">
        <Route element={<Layout data-id="element-10" />} data-id="element-9">
          <Route path="/experten/naechtliche-ruhe-optimieren" element={<ArticlePage data-id="element-12" />} data-id="element-11" />
          <Route path="/impressum" element={<Impressum data-id="element-14" />} data-id="element-13" />
          <Route path="/datenschutz" element={<Datenschutz data-id="element-16" />} data-id="element-15" />
          <Route path="/kontakt" element={<Kontakt data-id="element-18" />} data-id="element-17" />
          <Route path="*" element={<Navigate to="/experten/naechtliche-ruhe-optimieren" replace data-id="element-20" />} data-id="element-19" />
        </Route>
      </Routes>
      <CookieBanner data-id="element-21" />
    </>;
}